import { useSetAtom } from "jotai";
import { useSetRecoilState } from "recoil";

import { useFeatureGates } from "../../cof-feature-gates/hooks";
import { organizationsRefetchState } from "../../core/recoil/organizations";
import { organizationsV2RefetchAtom } from "../../core/recoil/organizationsV2";
import { CofConfigId } from "../../gql-generated/types";

export const useOrganizationsRefetch = (): ((update: (prev: number) => number) => void) => {
    const { configs } = useFeatureGates();
    const isMyLensesOrgsV2Enabled = configs[CofConfigId.MyLensesOrgsV2].enabled;

    const setRefetchCounterV1 = useSetRecoilState(organizationsRefetchState);
    const setRefetchCounterV2 = useSetAtom(organizationsV2RefetchAtom);

    return isMyLensesOrgsV2Enabled ? setRefetchCounterV2 : setRefetchCounterV1;
};
